// @flow

type Resource = {
  calendars: any,
  capacity: number,
  closedTimeRanges: any,
  divisible: boolean,
  human: 0 | 1,
  id: number,
  name: string,
  quantity: number,
  scheduleType: string,
  staffType: number,
  user: any
};

type UnitResource = {
  _embedded: {
    resource: Resource,
    units: Array<Unit>
  }
};

/**
 * If the product is linked to resources (staff or material)
 * return the remaining capacity per unit
 * depending on the quantities currently selected
 */
const getUnitsRemainingCapacity = (
  units: Array<Unit>,
  productUnitResources: Array<UnitResource>,
  quantities: Map<number, number>,
  resultMapRessource: Array<UnitResource>,
  quantity: number,
  unitId: number,
  maxParticipants: number

) => {

  const unitResourceMap = new Map();
  if (productUnitResources && productUnitResources.length > 0) {

    // tableau de resource avec la liste des unitId associé
    for (const units of productUnitResources) {
      const resourceId = units._embedded.resource.id;
      for (const unit of units._embedded.units) {
        // creation d'un Map avec les ressources associé a un Unit
        if (unitResourceMap.has(unit.id)) {
          // Si l'unité existe déjà dans la Map, on ajoute l'ID de la nouvelle ressource
          unitResourceMap.get(unit.id).push(resourceId);
        } else {
          // Si l'unité n'existe pas encore, on crée un tableau avec la première ressource
          unitResourceMap.set(unit.id, [resourceId]);
        }
      }
    }
  }

  // tableau de ressource lié a la main unit
  const unitResourceSharedMap = [];
  units.map(unit => {
    if (unit.prices[0].mandatoryMainUnitQuantity > 0) {
      unitResourceSharedMap.push(unit.id)
    }
  })

  function calculRemainingCapacity(emulationQuantities) {

    // emulation tableau gestion des ressources
    const emulationResultMapRessource = new Map(resultMapRessource);
    for (const unit of emulationQuantities) {
      const unitId = unit[0];
      const unitQt = unit[1];

      let unitResource = unitResourceMap.get(unitId) || [];
      for (const resourceId of unitResource) {
        emulationResultMapRessource.set(resourceId, emulationResultMapRessource.get(resourceId) - unitQt);
      }

    }

    // Valeur la plus petite dans le map
    let filteredResourcesValues = Array.from(emulationResultMapRessource.values());
    let minFilteredResourcesValue = null;

    if (Math.min(...filteredResourcesValues) < 0) {
      minFilteredResourcesValue = 0
    }

    // max participant
    const totalParticipants = Array.from(emulationQuantities).reduce(
      (acc, quantity) => acc + quantity[1],
      0
    );

    if (maxParticipants < totalParticipants) {
      minFilteredResourcesValue = 0
    }
    return minFilteredResourcesValue
  }

  return units.map(unit => {

    let unitPrices = unit.prices[0];

    // emulation tableau gestion des quantites
    let emulationQuantities = new Map(quantities);
    let emulationTargetUnitQuantityToAdd = null;

    //
    if (unitPrices.targetUnitQuantityMode === 1 && unitPrices.minTargetUnitQuantity !== 0 && quantities.get(unit.id) == null) {
      emulationTargetUnitQuantityToAdd = unitPrices.minTargetUnitQuantity
    } else {
      emulationTargetUnitQuantityToAdd = (quantities.get(unit.id) || 0) + 1;
    }
    emulationQuantities.set(unit.id, emulationTargetUnitQuantityToAdd);

    // Traitement dépendance avec unit Principale
    if (unitPrices.mandatoryMainUnitQuantity > 0) {
      // recupe id main unit
      let mainUnitId = units.find(unit => unit.type === 'MAIN').id;
      let mainUnitQuantityToAdd = 0;

      // check si la unit est présente dans le tableau
      let totalMainUnitToAdd = 0;
      if (unitResourceSharedMap.length > 0) {
        for (const ResourceSharedMap of unitResourceSharedMap) {
          let mandatoryMainUnitQuantity = units.find(unit =>
            unit.id === ResourceSharedMap
          ).prices[0].mandatoryMainUnitQuantity;

          totalMainUnitToAdd += (emulationQuantities.get(ResourceSharedMap) || 0) / mandatoryMainUnitQuantity;
        }
      }

      mainUnitQuantityToAdd = Math.ceil(totalMainUnitToAdd - (quantities.get(mainUnitId) || 0))
      if (mainUnitQuantityToAdd >= 0) {
        emulationQuantities.set(mainUnitId, (quantities.get(mainUnitId) || 0) + mainUnitQuantityToAdd);
      }
    }


    return {
      id: unit.id,
      remainingCapacity: calculRemainingCapacity(emulationQuantities)
    };
  })

}

export default getUnitsRemainingCapacity;
